import { render, staticRenderFns } from "./SpriteRatingEmoji.vue?vue&type=template&id=7e573b07&"
import script from "./SpriteRatingEmoji.vue?vue&type=script&lang=js&"
export * from "./SpriteRatingEmoji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports